export default function WorkExperience() {
    return (
        <section className="work-experience" id="experience">
            <h2>Work Experience</h2>

            <div className="work-experience-content">
                <h3>Application Engineer III at Amazon, Bangalore</h3>
                <p>July 2022 – Present</p>
                <ul>
                    <li>Built a React dashboard used by 50+ engineers to track 500 tickets/week by issue type, reducing triage time by 40% and improving prioritization.</li>
                    <li>Integrated frontend UI testing with backend configuration, reducing test time by 99% and accelerating vendor chat prompt validation.</li>
                    <li>Built a web-based testing interface using vanilla JavaScript and Java backend to validate Alexa beta devices, ensuring readiness for millions of customers during Prime Day.</li>
                    <li>Provided 12x7 on-call UI support, resolving critical customer-facing issues with minimal downtime and collaborating with cross-functional teams to ensure system stability.</li>
                    <li>Worked with 3+ retail teams to deliver 25+ API integrations, automating 10+ visual workflows and eliminating manual effort equivalent to 50+ headcounts.</li>
                </ul>
            </div>

            <div className="work-experience-content">
                <h3>Frontend Developer at Rexd Technologies, Bangalore</h3>
                <p>October 2021 – June 2022</p>
                <ul>
                    <li>Built home and product detail pages, boosting load speed by 30% via asset optimization.</li>
                    <li>Increased engagement by 15% with interactive UI and MongoDB CRUD; optimized performance using image compression and Chrome Lighthouse fixes.</li>
                    <li>Used React Context and Redux to manage cart, user, and filter state, cutting bugs by 40% and speeding up feature delivery.</li>

                </ul>
            </div>

            <div className="work-experience-content">
                <h3>Course Instructor (Part-time) at CampK12, Online</h3>
                <p>June 2020 – October 2021</p>
                <ul>
                    <li>Taught 100+ students in HTML, CSS, JavaScript, Python, and 3D JavaScript Game Design.</li>
                    <li>Maintained a 4.9/5.0 student rating across 50+ live sessions with high engagement and satisfaction.</li>
                    <li>Resolved 1000+ real-time student doubts, improving course completion rate by 20%.</li>
                </ul>
            </div>
            <div className="work-experience-content">
                <h3>India Web Designs, Guwahati — Website Developer (Internship)</h3>
                <p>July 2019 - Feb 2020</p>
                <ul>
                    <li>Delivered 4+ e-commerce projects using WordPress and PHP for regional clients,
                    improving their online visibility and conversion rates.</li>
                    <li>Developed a Django-based school website used by 500+ students and staff for
                    academic resources and announcements.</li>
                    <li>Worked closely with UI designers to enhance accessibility and responsiveness across
                    devices, leading to a 40% reduction in user drop-off.</li>
                </ul>
            </div>
        </section>
    );
}
